export enum FieldChartType {
    CUSTOM_1 = "CUSTOM_1",
    CUSTOM_2 = "CUSTOM_2",
    CUSTOM_3 = "CUSTOM_3",
    VIRTUAL_SOIL_MOISTURE_PROBE = "VIRTUAL_SOIL_MOISTURE_PROBE",
    ACTUAL_EVAPOTRANSPORTATION = "ACTUAL_EVAPOTRANSPORTATION",
    VIRTUAL_TENSIOMETER = "VIRTUAL_TENSIOMETER",
    EVAPOTRANSPIRATION_APPLIED_WATER_CUMULATIVE = "EVAPOTRANSPIRATION_APPLIED_WATER_CUMULATIVE",
    DRY_MATTER_PRODUCTION_CUMULATIVE = "DRY_MATTER_PRODUCTION_CUMULATIVE",
    PERCENT_VEGETATION_COVER = "PERCENT_VEGETATION_COVER",
    LEAF_NITROGEN = "LEAF_NITROGEN",
    NET_CARBON_SUPPLY_IN_SOIL = "NET_CARBON_SUPPLY_IN_SOIL",
    PRECIPITATION = "PRECIPITATION",
    AIR_TEMPERATURE_AND_GDU = "AIR_TEMPERATURE_AND_GDU",
}
